import PublicEnv from 'shared/utils/public-env';

/**
 * Gate for DevAccountPicker. Requires an explicit opt-in
 * (ENABLE_DEV_ACCOUNT_PICKER) rather than inferring from appEnv, so it stays
 * off in demo/staging/preview unless an environment deliberately turns it on.
 * appEnv !== 'production' is kept as a second, independent guard: even if the
 * opt-in var were ever set in production by mistake, this still blocks it.
 *
 * Duplicated identically in apps/marketplace rather than shared via
 * packages/shared. This tiny function is cheap to keep in sync; keep both
 * copies identical if you change this logic.
 */
export function shouldShowDevAccountPicker(): boolean {
  return PublicEnv.enableDevAccountPicker === 'true' && PublicEnv.appEnv !== 'production';
}
